import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConferenceSpeakerExpenseViewModel, ConferenceSpeakerViewModel } from 'src/app/_models/generatedModels';
import { ConferenceExpenseTrackingService } from 'src/app/_services/generatedServices';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToasterService } from 'src/app/_services/toaster.service';
import { EditMyExpenseModalComponent } from './edit-my-expense-modal.component';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { SettingsProvider } from 'src/app/_services/settingsProvider.service';
import { BlobStorageService } from 'src/app/_services/blob-storage.service';

@Component({
  selector: 'bxl-my-expenses-for-conference',
  templateUrl: 'my-expenses-for-conference.component.html',
})
export class MyExpensesForConferenceComponent implements OnInit {
  initialized = false;
  conferenceId: number;
  userId: number;
  organizationId: string;
  stripeUrl = '';

  speaker: ConferenceSpeakerViewModel;
  constructor(private route: ActivatedRoute, private settings: SettingsProvider, public auth: AuthenticationService, private modalService: NgbModal, private toastr: ToasterService, private expenseTracking: ConferenceExpenseTrackingService, private blobService: BlobStorageService) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((param) => {
      this.auth.fetchUserProfile().subscribe((profile) => {
        this.userId = profile.id;
        this.conferenceId = +param.get('conferenceId');
        this.loadConnectButton();
        this.getData();
      });
    });
  }

  getData() {
    this.expenseTracking.getMyExpenses(this.conferenceId).subscribe((result) => {
      this.speaker = result;
      this.organizationId = this.speaker.organizationId.toString();
      this.initialized = true;
    });
  }

  loadConnectButton() {
    let redirect_uri = this.settings.siteUrl + '/account/stripe-complete-oauth';
    this.stripeUrl = 'https://connect.stripe.com/express/oauth/authorize?redirect_uri=' + redirect_uri + '&client_id=' + this.settings.stripeClientKey + '&state=conf:' + this.conferenceId + '&&stripe_user[email]=' + this.auth.user.email + '&stripe_user[first_name]=' + this.auth.user.firstName + '&stripe_user[last_name]=' + this.auth.user.lastName; // + '&suggested_capabilities[]=transfers&suggested_capabilities[]=tax_reporting_us_1099_k&tos_acceptance[service_agreement]=recipient';
  }

  downloadReceipt(expense: ConferenceSpeakerExpenseViewModel) {
    if (!expense.receiptImage) {
      this.toastr.messageDialog('No Receipt available for this expense.', 'No Receipt').subscribe();
      return;
    }

    this.blobService.downloadFile('fetchImage?filename=' + expense.receiptImage ,expense.fileName);
  }

  deleteExpense(expense: ConferenceSpeakerExpenseViewModel) {
    if (expense && expense.paid) {
      this.toastr.messageDialog('This expense has already been paid out and cannot be edited.', 'Expense Paid').subscribe();
      return;
    }

    if (expense.createdById != this.auth.user.id) {
      this.toastr.messageDialog('You can only delete expenses that you have created.', 'Expense Not Created By You').subscribe();
      return;
    }

    this.toastr.confirmDialog('Are you sure you want to delete this expense?', 'Delete Expense').subscribe((result) => {
      if (result) {
        this.expenseTracking.deleteExpense(this.organizationId, this.conferenceId, this.userId, expense.id).subscribe((result) => {
          this.toastr.success('Expense Deleted', 'Success');
          this.getData();
        });
      }
    });
  }

  addEditExpense(expense: ConferenceSpeakerExpenseViewModel) {
    if (expense && expense.paid) {
      this.toastr.messageDialog('This expense has already been paid out and cannot be edited.', 'Expense Paid').subscribe();
      return;
    }

    if (expense && expense.createdById != this.auth.user.id) {
      this.toastr.messageDialog('You can only edit expenses that you have created.', 'Expense Not Created By You').subscribe();
      return;
    }

    const modalRef = this.modalService.open(EditMyExpenseModalComponent, { size: 'lg', keyboard: false, ariaLabelledBy: 'modal-basic-title', windowClass: 'flyout', backdropClass: 'flyout', backdrop: 'static' });
    modalRef.componentInstance.conferenceId = this.conferenceId;
    modalRef.componentInstance.userId = this.userId;
    modalRef.componentInstance.expense = expense;
    modalRef.result.then(
      (result) => {
        this.getData();
      },
      (reason) => {
        this.getData();
      }
    );
  }
}
